import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpService} from './http.service';
import {BaseResponse} from '../models/respose/BaseResponse';
import {Subject} from '../models/Subject';

@Injectable({
  providedIn: 'root'
})
export class SubjectService extends HttpService {

  constructor(http: HttpClient) {
    super(http);
  }

  getAll(): Observable<BaseResponse<Subject[]>>{
    return this.get('subjects/index');
  }

}
